import { MenuItemsType, SwapIcon, SwapFillIcon, MoreIcon, DropdownMenuItems } from '@pancakeswap/uikit'
import { ContextApi } from '@pancakeswap/localization'
import { IS_PROD } from '@pancakeswap/address-config'

export type ConfigMenuDropDownItemsType = DropdownMenuItems & { hideSubNav?: boolean }
export type ConfigMenuItemsType = Omit<MenuItemsType, 'items'> & { hideSubNav?: boolean; image?: string } & {
  items?: ConfigMenuDropDownItemsType[]
}

const addMenuItemSupported = (item, chainId) => {
  if (!chainId || !item.supportChainIds) {
    return item
  }
  if (item.supportChainIds?.includes(chainId)) {
    return item
  }
  return {
    ...item,
    disabled: true,
  }
}

// const config: (
//   t: ContextApi['t'],
//   isDark: boolean,
//   languageCode?: string,
//   chainId?: number,
// ) => ConfigMenuItemsType[] = (t, isDark, languageCode, chainId) =>
//   [
//     {
//       // label: t('Info'),
//       label: 'Dashboard',
//       href: '/info/v3',
//       icon: MoreIcon,
//       items: [],
//     },
//     {
//       label: t('Swap'),
//       icon: SwapIcon,
//       fillIcon: SwapFillIcon,
//       href: '/swap',
//       showItemsOnMobile: false,
//       hideSubNav: true,
//       items: [],
//     },
//     {
//       label: t('Liquidity'),
//       href: '/liquidity',
//       items: [],
//     },
//     // IS_PROD
//     //   ? []
//     //   : [
//     //     ],
//   ]
//     .concat(
//       IS_PROD
//         ? [
//             {
//               label: t('Perp'),
//               href: '/perp',
//               items: [
//                 {
//                   label: t('Trade'),
//                   href: '/perp/trade',
//                   items: [],
//                 },
//                 {
//                   label: t('ALP'),
//                   href: '/perp/alp',
//                   items: [],
//                 },
//                 {
//                   label: t('Referral'),
//                   href: '/perp/referral',
//                   items: [],
//                 },
//               ],
//             },
//             {
//               label: t('Bridge'),
//               href: '/bridge',
//               items: [
//                 {
//                   label: t('Squidrouter'),
//                   href: '/bridge/squid',
//                   items: [],
//                 },
//                 {
//                   label: t('CEX Bridge'),
//                   href: '/bridge/cede',
//                   items: [],
//                 },
//                 {
//                   label: t('Wormhole'),
//                   href: '/bridge/wormhole',
//                   items: [],
//                 },
//               ],
//             },
//           ]
//         : [
//             {
//               label: t('Farms'),
//               href: '/farms',
//               items: [],
//             },
//             {
//               label: t('LaunchPad'),
//               href: '/launchpad',
//               items: [],
//             },
//             {
//               label: t('Perp'),
//               href: '/perp',
//               items: [
//                 {
//                   label: t('Trade'),
//                   href: '/perp/trade',
//                   items: [],
//                 },
//                 {
//                   label: t('ALP'),
//                   href: '/perp/alp',
//                   items: [],
//                 },
//                 {
//                   label: t('Referral'),
//                   href: '/perp/referral',
//                   items: [],
//                 },
//               ],
//             },
//             {
//               label: t('Bridge'),
//               href: '/bridge',
//               items: [
//                 {
//                   label: t('Squidrouter'),
//                   href: '/bridge/squid',
//                   items: [],
//                 },
//                 {
//                   label: t('CEX Bridge'),
//                   href: '/bridge/cede',
//                   items: [],
//                 },
//                 {
//                   label: t('Wormhole'),
//                   href: '/bridge/wormhole',
//                   items: [],
//                 },
//               ],
//             },
//           ],
//     )
//     .map((item) => addMenuItemSupported(item, chainId))

const config: (
  t: ContextApi['t'],
  isDark: boolean,
  languageCode?: string,
  chainId?: number,
) => ConfigMenuItemsType[] = (t, isDark, languageCode, chainId) =>
  [
    {
      label: t('Trade'),
      href: '/perp/trade',
      items: [],
    },
    {
      label: t('PLP'),
      href: '/perp/plp',
      items: [],
    },
    {
      label: t('Referral'),
      href: '/perp/referral',
      items: [],
    },
  ].map((item) => addMenuItemSupported(item, chainId))

export default config
